import React from 'react';

/**
 * SectionHeader renders a consistent title block for each wizard step.
 *
 * @param {number} number - Section number (1–14).
 * @param {string} title  - Section title.
 * @param {string} [tip]  - Optional advisory tip displayed below the title.
 * @param {boolean} [showAnnualNote=true] - Show the default annual-amount helper line.
 */
export default function SectionHeader({
  number,
  title,
  tip,
  showAnnualNote = true,
}) {
  return (
    <div className="mb-4">
      <div className="d-flex align-items-baseline gap-2">
        {number != null && number !== '' && (
          <span
            className="badge rounded-pill cashflow-badge-dark"
            style={{ fontSize: '0.85rem', padding: '0.35em 0.8em' }}
          >
            {number}
          </span>
        )}
        <h2 className="h4 fw-bold mb-0">{title}</h2>
      </div>
      {tip && (
        <div className="alert alert-light border-start border-4 border-danger mt-3 mb-0 py-2 small">
          <i className="bi bi-lightbulb me-2 text-danger" />
          {tip}
        </div>
      )}
      {showAnnualNote && (
        <p className="text-muted small mt-2 mb-0">
          Enter <strong>annual</strong> amounts (yearly totals).
        </p>
      )}
    </div>
  );
}
